import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BrowserStorageService } from './browser-storage.service';
import { EncryptionService } from './encryption.service';

interface verifyAuthBody {
  totp_code: string;
} 

@Injectable({
  providedIn: 'root'
})
export class VerifyAuthCodeService {
  
  private readonly apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, private storage: BrowserStorageService, private encryption: EncryptionService) { }
  enableCode(code: string): Observable<any> {

    const url = `${this.apiUrl}/api/users/auth/2fa/enable/`;
    const encryptedAccess = this.storage.getSessionStorageItem('access');
    let accessToken = '';
    accessToken = this.encryption.decrypt(String(encryptedAccess));
     
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    });

    // Enviar claves comunes que suelen aceptar APIs de 2FA
    const body: verifyAuthBody = {
      totp_code: code
    };

    return this.http.post(url, body, { headers });
  }

  generate2FA(): Observable<any> {
    const url = `${this.apiUrl}/api/users/auth/2fa/generate/`;
    // Obtener y desencriptar access
    const encryptedAccess = this.storage.getSessionStorageItem('access');
    let accessToken = '';
    if (encryptedAccess) {
      accessToken = this.encryption.decrypt(encryptedAccess);
    }

    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {})
    });

    return this.http.post(url, {}, { headers });
  }
}
